module.exports = __webpack_public_path__ + "static/media/arrow-right-black.ca11adad.svg";